var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('speakers-editor',{attrs:{"disabled":_vm.project.isArchived},model:{value:(_vm.speakers),callback:function ($$v) {_vm.speakers=$$v},expression:"speakers"}})}
var staticRenderFns = []

export { render, staticRenderFns }